import { createPortal } from 'react-dom';
import { Modal } from '@carbon/react';
import type { SharedRenameModalProps } from './types';

/**
 * Asks the user to confirm renaming an entity that other parties share.
 *
 * @param {SharedRenameModalProps} props - Whether it is open, its message, and the confirm and cancel callbacks.
 * @return {React.ReactPortal} The modal, portaled to the document body.
 */
export function SharedRenameModal({
  open,
  message,
  onConfirm,
  onCancel,
}: SharedRenameModalProps) {
  return createPortal(
    <Modal
      open={open}
      modalHeading="Rename Shared Entity"
      primaryButtonText="Rename"
      secondaryButtonText="Cancel"
      onRequestSubmit={onConfirm}
      onRequestClose={onCancel}
      onSecondarySubmit={onCancel}
    >
      <p>{message}</p>
    </Modal>,
    window.document.body
  );
}
